import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Header } from "@/components/universal/header";
import RecallForm from "./-form";

export const Route = createFileRoute("/_private/_inventory-360/recall/create")({
  component: RecallCreatePage,
});

function RecallCreatePage() {
  return (
    <div>
      <title>Create Recall - Legrande Health Portal</title>
      <Header
        crumbs={[
          { name: "Recalls", link: { to: "/recall/lookup" } },
          { name: "Create Recall", link: { to: "/recall/create" } },
        ]}
      />
      <Card>
        <CardHeader>
          <CardTitle>Create Recall</CardTitle>
          <CardDescription>
            Select the recalled lot and record the recall details.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <RecallForm />
        </CardContent>
      </Card>
    </div>
  );
}
